export default {"glow":"_69S6C"};